import { api, client } from "@/client";
import { defineStore, acceptHMRUpdate } from "pinia";

export const useWorkflowStore = defineStore("workflow", {
  state: () => ({
    workflowList: [{}],
    loading: false,
    currentBatch: {},
  }),
  getters: {},
  actions: {
    async fetchWorkflow() {
      this.$reset;
      this.workflowList = [
        {
          id: "abs7987df879s7f8",
          created_at: "1971-08-28T10:17:32Z",
          definition_file: "//path/desktop/??",
          version_number: "0.2",
          status: "Completed",
          name: "Workflow for EAS A",
          workflow_type: "EAS_A",
        },
        {
          id: "7fa8sd7f97ds9a8f7",
          created_at: "1997-11-24T20:23:13Z",
          definition_file: "//path/desktop/??",
          version_number: "0.5",
          status: "Completed",
          name: "Workflow for EAS B",
          workflow_type: "EAS_C",
        },
        {
          id: "ghj67fg876wqre67d",
          created_at: "2010-11-24T20:23:13Z",
          definition_file: "//path/desktop/??",
          version_number: "0.8",
          status: "Completed",
          name: "Workflow for EAS C",
          workflow_type: "EAS_B",
        },
        {
          id: "f89g6hn89790ds8af",
          created_at: "2020-11-24T20:23:13Z",
          definition_file: "//path/desktop/??",
          version_number: "0.1",
          status: "Completed",
          name: "Workflow for BAGGIT",
          workflow_type: "BAGGIT",
        },
      ];
    },
    fetchCurrent(params: any) {},
    confirm(locationName: string) {},
    reject() {},
  },
});
if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useWorkflowStore, import.meta.hot));
}
